<!--
    描述：主体管理 --- 审计单位列表
    时间：2021-06-18
    Created by 王帅
-->
<template>
    <div class="w-page-main">
        <div class="w-page-header">
            <div class="left-text overflow-hidden">
                <span><b>{{ currentRowName }}列表</b></span>
            </div>
            <div class="btnGroups ml10">
                <SearchArea ref="searchContent" v-model="unitName" placeholderName="单位名称"
                    @on-search="onFilter" @on-refresh="onRefresh" :showMore="false">
                </SearchArea>
            </div>
        </div>

        <div class="w-page-container pdb10">
            <div class="w-table-layout">
                <div class="w-table-content" ref="tableContent">
                    <el-table
                        ref="xTable"
                        :data="tableObj.data"
                        :loading="tableObj.loading"
                        :height="tableObj.tableH"
                        border
                        highlight-current-row
                    >
                        <el-table-column
                            type="index"
                            show-overflow-tooltip
                            align="center"
                            label="序号"
                            width="70"
                        ></el-table-column>
                        <el-table-column
                            prop="sname"
                            label="名称"
                            header-align="center"
                            align="left"
                            show-overflow-tooltip
                            min-width="150"
                        ></el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import SearchArea from '@/components/searchArea/searchArea'
export default {
    name: "",
    components: {
        SearchArea
    },
    props: {
        // 当前主体单位名称
        currentRowName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            tableObj: {
                loading: false,
                tableH: 200,
                data: [],
                expandKeys: [],
            },
            // 筛选的单位名称
            defaultData: [],
            unitName: '',
        };
    },
    mounted() {
        this.$nextTick(() => {
            setTimeout(() => {
                this.tableObj.tableH = this.$refs.tableContent.offsetHeight
            }, 100)
        })
    },
    methods: {
        // 筛选单位
        onFilter() {
            let arr = this.$utils.filterTree(this.defaultData, x => x.sname.indexOf(this.unitName) >= 0)
            this.tableObj.data = arr
        },

        // 清除筛选
        onRefresh() {
            this.unitName = ''
            this.onFilter()
        }
    },
    computed: {
        ...mapState('app', { clientSize: state => state.clientSize }),
    },
    watch: {
        clientSize(val) {
            this.tableObj.tableH = this.$refs.tableContent.offsetHeight
        }
    }
};
</script>

<style scoped lang="less"></style>
